import {TranslationValues} from 'next-intl';
import {TranslateKey} from '../locale/type';
import {t} from './getTranslations';

export function getTranslatedApiMessage(response: {
  message: string;
  message_key?: TranslateKey;
  message_params?: TranslationValues;
}) {
  if (!response.message_key) {
    return response.message;
  }

  const translatedMessage = t(response.message_key, {
    values: response.message_params,
  });

  // 번역 함수의 결과물이 원본과 같다면 번역이 정상적으로 되지 않은 것이므로 예외처리 합니다.
  // 번역키가 없을 경우 t함수는 번역키를 그대로 리턴하기 때문에 번역키로 비교합니다.
  if (response.message_key === translatedMessage) {
    return t('error_undefined_toast', {
      values: {value: response.message_key},
    });
  }

  return translatedMessage;
}
